"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var tinyYolov2_1 = require("../tinyYolov2");
var TinyFaceDetectorOptions = /** @class */ (function (_super) {
    tslib_1.__extends(TinyFaceDetectorOptions, _super);
    function TinyFaceDetectorOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._name = 'TinyFaceDetectorOptions';
        return _this;
    }
    return TinyFaceDetectorOptions;
}(tinyYolov2_1.TinyYolov2Options));
exports.TinyFaceDetectorOptions = TinyFaceDetectorOptions;
//# sourceMappingURL=TinyFaceDetectorOptions.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/tinyFaceDetector/TinyFaceDetectorOptions.js
 ** module id = 624
 ** module chunks = 0
 **/